import { Component, OnInit } from '@angular/core';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {
  IPlatformToolHandler,
  IPlatformToolLeftSidePanel
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'app-file-store-left-panel',
  templateUrl: './file-store-left-panel.component.html',
  styleUrls: ['./file-store-left-panel.component.scss']
})
export class FileStoreLeftPanelComponent implements OnInit , IPlatformToolLeftSidePanel {
  magicLinkModel: MagicLinkModel;
  isClientDrive = true;
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  driveId: string;
  shortcutTags: string[] = [];
  shortCuts: any;
  hasShortcutItem = true;
  constructor() { }

  ngOnInit(): void {
  }

  onLoad() {
    this.isClientDrive = this.magicLinkModel.leftPanel.data['IsClientDrive'];
    this.driveId = this.magicLinkModel.leftPanel.data['DriveId'];
    this.shortcutTags = this.magicLinkModel.leftPanel.data['Tags'];
    this.shortCuts = this.magicLinkModel.leftPanel.data['ShortCutsList'];
    if (this.magicLinkModel.leftPanel.data.hasOwnProperty('HasShortcutItem')) {
      this.hasShortcutItem = this.magicLinkModel.leftPanel['HasShortcutItem'];
    }
  }

}
